@if (compact()) {
  <button
    mat-icon-button
    type="button"
    [disabled]="disabled()"
    [attr.aria-label]="'waters.price-lists.add' | translate"
    [matTooltip]="'waters.price-lists.add' | translate"
    (click)="add()">
    <mat-icon>add</mat-icon>
  </button>
} @else {
  <button mat-stroked-button type="button" [disabled]="disabled()" (click)="add()">
    <mat-icon>add</mat-icon>
    {{ 'waters.price-lists.add' | translate }}
  </button>
}
